import React from "react";

import { Routing } from "@common/_constants";
import { Button } from "@common/components/Atoms/Button";
import Modal from "@common/components/Molecules/Modal";

interface SMSOptionsProps {
    isOpen: boolean,
    onOkay: () => void,
    onCancel: () => void,
    closeModal: () => void,
};

export const SMSOptions: React.SFC<SMSOptionsProps> = (props: SMSOptionsProps) => (
    <Modal isOpen={props.isOpen} closeModal={props.closeModal}>
        <div className="c-block">
            <div className="c-block__title">SMS Info...</div>
            <div className="c-block__body">
                <p>
                    Message frequency for security alerts varies based upon the number of service
                    exchanges.
                </p>
                <p>
                    Msg&Data Rates May Apply. For each of the above programs. I agree to Relodes's{" "}
                    <a
                        href={Routing.Marketing.POLICY_TERMS}
                        target="_blank"
                        className="c-link c-link--magenta">
                        Terms & Conditions
                    </a>{" "}
                    and{" "}
                    <a
                        href={Routing.Marketing.POLICY_PRIVACY}
                        target="_blank"
                        className="c-link c-link--green">
                        Privacy Policy
                    </a>. I can text STOP to cancel or HELP for help. Customer Service 844-773-5633.
                    Supported carriers: AT&T, Verizon Wireless, T-Mobile, Metro PCS, Sprint, U.S.
                    Cellular, Cincinnati Bell and others.
                </p>
            </div>
        </div>
        <div className="c-modal__footer">
            <div className="c-modal__footer-left" />
            <div className="c-modal__footer-right">
                <Button id="sms-options-okay-button" green={true} onClick={props.onCancel}>
                    Okay
                </Button>
            </div>
        </div>
    </Modal>
);


